import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ContractPartnerPrivateForm } from '../../new-contract-partner.utils';
import { DatepickerComponent } from '@shared-ikp/components/datepicker/datepicker.component';
import { buildPrivatePersonForm } from './private-person-form.utils';
import { ContractPartnerType, MeterPointChangeSignalState } from '../../../meterpoint-change-request.types';
import { SignalState } from '@shared-ikp/service/signal-state-service/signal-state.service';
import { maxBirthDate, minBirthDate } from '@shared-ikp/utils/datepicker';

@Component({
  selector: 'ikp-private-person-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe, DatepickerComponent],
  templateUrl: './private-person-form.component.html',
})
export class PrivatePersonFormComponent {
  protected readonly wizardStore: MeterPointChangeSignalState = inject(SignalState);
  protected form: FormGroup;

  constructor() {
    const currentFormState = this.wizardStore.state().newContractPartner.formData?.privatePartner;
    this.form = buildPrivatePersonForm(inject(FormBuilder), currentFormState);
  }

  public get validForSubmission(): boolean {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
    const isFormValid = this.form.valid;

    if (isFormValid) {
      this.wizardStore.patchState({
        newContractPartner: {
          ...this.wizardStore.state().newContractPartner,
          emptyPartner: null,
          formData: {
            partnerType: ContractPartnerType.PRIVATE,
            privatePartner: this.form.value,
          },
        },
      });
    }
    return isFormValid;
  }

  protected getFormError(key: keyof ContractPartnerPrivateForm): string {
    const formKey = this.form.get(key);
    if (formKey.errors) {
      return formKey.errors.translationKey;
    }
    return null;
  }

  protected isInputInvalid(key: keyof ContractPartnerPrivateForm) {
    return this.form.get(key).touched && this.form.get(key).invalid;
  }

  protected readonly minBirthDate = minBirthDate;
  protected readonly maxBirthDate = maxBirthDate;
}
